// La ruta del modo Catálogo (ADR-2026-10-13-catalogo-con-el-agente). Sin `:sesionId` es la
// portada; con él, la sesión. Marcas de Hogar y Decoración y de los rubros no principales
// (ADR-2026-10-26-catalogo-con-el-agente-para-los-rubros-no-principales); Moda y Belleza
// tienen Generación en lote (los dev testers lo ven con cualquier marca, para probarlo). Desde el 2026-10-15 también en el teléfono, con el agente en
// una pastilla abajo (ADR-2026-10-15-el-catalogo-en-el-telefono). Entrar no pide plan: generar
// chequea el saldo adentro.
import { Sofa } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useRubroMarcaActiva } from '../../../../hooks/useRubroMarca';
import { useUserGroup } from '../../../../hooks/useUserGroup';
import { rubroVeCatalogoConAgente } from '../../../../lib/rubro';
import { PantallaCatalogo } from './PantallaCatalogo';

const Aviso: React.FC<{ icono: React.ReactNode; titulo: string; texto: string }> = ({ icono, titulo, texto }) => (
  <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center">
    {icono}
    <p className="text-[16px] font-semibold text-brand-black">{titulo}</p>
    <p className="max-w-md text-[14px] text-[#3C3C43]/60">{texto}</p>
  </div>
);

const CatalogoAgenteMode: React.FC = () => {
  const { sesionId } = useParams<{ sesionId?: string }>();
  const { rubro, loaded } = useRubroMarcaActiva();
  const { isDevTester } = useUserGroup();

  if (loaded && !rubroVeCatalogoConAgente(rubro) && !isDevTester) {
    return (
      <Aviso
        icono={<Sofa className="h-8 w-8 text-[rgb(var(--brand-black-rgb)_/_0.4)]" aria-hidden="true" />}
        titulo="Catálogo no está para tu rubro"
        texto="Para las marcas de Moda y de Belleza está Generación en lote, que arma varias vistas de cada producto en una tanda."
      />
    );
  }
  return <PantallaCatalogo sesionId={sesionId} />;
};

export default CatalogoAgenteMode;
